import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';

const hospitalPoiStyle = 
new Style({
  image: new Icon({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'data/icons/24px/hospital.png',
    color: '#BA274A',
    scale: 0.7
  }),
});

export const poiHospitalLayer = new VectorLayer({
source: new VectorSource({
  url: 'https://localhost:9000/poi/up/hospitals',
  format: new TopoJSON({
    layers: ['POI_major_hospital_Nursing_homes'],
  }),
  overlaps: true,
}),
//minZoom: POI_MIN_ZOOM_LEVEL - 1,
style: hospitalPoiStyle,
visible: true,
zIndex : 2
});
